export default __webpack_public_path__ + "static/media/TN.5c9568ac.ico";